<template>
  <div id="app">
    <!-- Loading UX -->
    <mu-dialog :open="pageLoading" width="90%">
      <div style="text-align: center;">
        <mu-circular-progress class="demo-circular-progress" :size="36"></mu-circular-progress>
        <div>{{ $t(loadingMsg) }}</div>
      </div>
    </mu-dialog>
    <!-- 裝置非手機 -->
    <mu-dialog :title="$t('Member.system')" width="550" :open="!isMoblie" @close="redirectOfficial">
      {{ $t('Member.no_service') }}
    </mu-dialog>
    <!-- 用戶資訊 -->
    <mu-dialog width="360" transition="slide-bottom" fullscreen :open.sync="uploadDia">
      <div :style="styleList">
        <mu-appbar color="primary" :title="$t(uploadTitle)">
          <mu-button slot="left" icon @click="closeFullscreenDialog">
            <mu-icon value="close"></mu-icon>
          </mu-button>
          <!-- <mu-button slot="right" flat @click="checkUpload" v-if="uploadBox && originImg === 'https://image.flaticon.com/icons/svg/149/149071.svg'">
            {{ $t('Member.save') }}
          </mu-button> -->
          <mu-button slot="right" flat @click="getBack" v-if="!uploadBox">
            {{ $t('Store.back') }}
          </mu-button>
        </mu-appbar>
        <div v-if="!uploadBox">
          <img :src="profileImg" width="100%"/>
        </div>
        <div style="padding: 16px; text-align: center;" v-if="uploadBox">
          <div style="margin-top: 15px;">
            <mu-avatar :size="100" style="border: 3px solid #eee;">
              <img :src="profileImg">
            </mu-avatar>
          </div>
          <div style="margin-top: 10px;" v-if="upload">
            <label class="btn-info" v-if="originImg === 'https://image.flaticon.com/icons/svg/149/149071.svg'" style="margin-right: 5px;">
              <input id="upload_img" style="display:none;" type="file" @change="onFileSelected">
              {{ $t('Member.upload') }}
            </label>
            <el-button type="info" size="small" @click="checkImg">{{ $t('Member.check_img') }}</el-button>
          </div>
          <div style="color: #f24; font-size: 14px; margin-top: 5px;" v-if="invalidImg">上傳的圖片格式有誤</div>
          <div style="margin-bottom: 10px; margin-top: 10px;">
            <mu-text-field style="padding-bottom: 0px;" v-model="username" :label="$t('Member.user_name')" label-float disabled></mu-text-field>
            <mu-text-field v-model="userPhone" :label="$t('Member.user_phone')" label-float disabled></mu-text-field>
            <mu-text-field v-if="hasEmail" v-model="userEmail" :label="$t('Member.user_email')" label-float disabled></mu-text-field>
            <mu-text-field v-if="hasLevel" v-model="exp" label="經驗值" label-float disabled></mu-text-field>
            <!-- <mu-text-field v-if="referalUrl !== ''" v-model="referalUrl" :label="$t('Member.recommend_url')" label-float></mu-text-field>
            <mu-icon class="dup" value="note_add"
              color="blue"
              @click="doCopy"></mu-icon> -->
          </div>
          <div class="demo-step-container" style="margin: -15px auto; border-radius: 5px; text-align: center;" v-if="hasLevel && level.list">
            <mu-stepper :active-step="level.activeStep">
              <mu-step v-for="(lev, index) in level.list" :key="lev.title">
                <mu-step-label>
                  <mu-icon slot="icon" value="lock_open" color="#fcba03" v-if="index <= level.activeStep - 1"></mu-icon>
                  <mu-icon slot="icon" value="lock" color="#888" v-if="index > level.activeStep - 1"></mu-icon>
                  {{ lev.title }}
                </mu-step-label>
              </mu-step>
            </mu-stepper>
            <div class="demo-step-content" style="text-align: left; padding-left: 11px; margin-top: -10px;">
              <span style="font-size: 15px;" v-if="level.activeStep === 0">距離下一等級: <span style="font-weight: 600; color: #444;">{{ level.list[0].title }}</span> 還差 <span style="color: #03B50F;">{{ level.list[0].exp - exp }}</span> 點經驗值</span>
              <span style="font-size: 15px;" v-else-if="level.activeStep <= level.list.length - 1">距離下一等級: <span style="font-weight: 600; color: #444;">{{ level.list[level.activeStep].title }}</span> 還差 <span style="color: #03B50F;">{{ level.list[level.activeStep].exp - exp }}</span> 點經驗值</span>
            </div>
          </div>
          <FlashMessage></FlashMessage>
        </div>
        <mu-dialog :open="checkUploadDia">
          {{ $t('Member.only_once') }}
          <mu-button slot="actions" flat color="primary" @click="checkUploadDia = false">{{ $t('Store.back') }}</mu-button>
          <mu-button slot="actions" color="primary" @click="sendUpload">{{ $t('Store.check') }}</mu-button>
        </mu-dialog>
        <mu-dialog :open="uploading">
          <mu-linear-progress style="width: 150px"/>
        </mu-dialog>
      </div>
    </mu-dialog>
    <!-- 上方區塊底色 -->
    <div style="height: 68px; z-index: 5000; background-color: #f7f7f7; position: fixed; top: 0; width: 100%;"></div>
    <!-- 頭像 -->
    <div style="position: fixed; left: 15px; top: 9px; cursor: pointer; z-index: 5000;">
      <mu-avatar :size="50" style="border: 3px solid #fff; box-shadow: 1px 1px 3px 1px rgba(20%, 20%, 20%, 0.2);" @click="openUpload">
        <img :src="profileImg">
      </mu-avatar>
      <div style="width: 200px; display: inline-block; margin-left: 5px; text-align: left; transform: translateY(5px);">
        <el-row>
          <el-col :span="24" style="font-weight: 500;">
            <div>{{ username }} <div class="tag" v-if="level.nowLevel">{{ level.nowLevel }}</div></div>
            <div style="margin-top: 3px;">
              {{ $t('Member.point') }}: <span style="color: #03b50f;">{{ userPointModel }}</span>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
    <!-- 首頁 -->
    <div v-if="isMoblie" style="padding-top: 10px;">
      <!-- 會員卡片 -->
      <es-Card v-if="num === 'card'"
        :logo="logo"
        :invoice="invoice"
        :memberUrl="memberUrl"
        :customLink="customLink"
        :showBtn="showBtn"
        :qrCode="qrcode"
        :only="onlyLogo"
        :userName="username"
        :barCode="barcode"/>
      <!-- 消費記錄 -->
      <es-History v-if="num === 'history'"
        :service="service"
        :height="height"
        :auth="auth"
        :only="onlyLogo"
        :id="id"
        :logo="logo"
        :ratio="ratio"/>
      <!-- 門市資訊 -->
      <es-ShopInfo v-if="num === 'store'"
        :height="historyHeight"
        :only="onlyLogo"
        :logo="logo"/>
      <!-- 商城 -->
      <es-Shop v-if="num === 'shop'"
        :shopHeight="shopHeight"
        :userTags="userTagList"
        :first="firstMessage"
        :memberUrl="memberUrl"
        :customLink="customLink"
        :userName="username"
        :level="level.list"
        :exp="exp"
        :shopData="shopData"
        :service="service"
        :auth="auth"
        :only="onlyLogo"
        :phone="userPhone"
        :store="shopStore"
        :storeList="allStore"
        :token="id"
        :logo="logo"/>
      <!-- 優惠 -->
      <es-Order v-if="num === 'queryOrder'"
        :orderLink="orderLink"
        :webHeight="webHeight"/>
      <!-- 商城外連結 -->
      <es-ShopLink v-if="num === 'iframe'"
        :type="linkType"
        :auth="auth"
        :linkArr="linkArr"
        :url="iframeData.url"
        :webHeight="webHeight"/>
      <!-- 預定功能 -->
      <es-Booking v-if="num === 'booking'"
        :only="onlyLogo"
        :height="height"
        :calendar="calendar"
        :service="service"
        :auth="auth"
        :userEmail="userEmail"
        :userName="username"
        :logo="logo"/>
      <!-- logo 區 -->
      <div style="padding-right: 10px; position: fixed; bottom: 80px; right: 0px; width: 50%; color: #999;" v-if="num !== 'iframe'">
        <a href="https://www.eilis-ai.com/" class="web" target="blank">會員系統由<br>EILIS 智慧互動助理提供</a>
      </div>
      <div id="logo" v-if="num !== 'iframe' && showLogo" style="position: fixed; bottom: 77px;">
        <el-row>
          <el-col :span="12">
            <!-- 有 logo -->
            <el-row style="padding-right: 10px; padding-left: 10px;" v-if="logo">
              <el-col :span="col()">
                <img :src="logo"
                  width="100%"/>
              </el-col>
              <el-col v-if="!onlyLogo" :span="col()" style="position: absolute; bottom: 0; right: 0;">
                <img src="./img/EILIS.png"
                  width="100%"
                  @click="OfficialSite"/>
              </el-col>
            </el-row>
            <!-- 無 logo -->
            <el-row style="padding-right: 10px; padding-left: 10px;" v-if="!logo">
              <el-col v-if="!onlyLogo" :span="col()">
                <img src="./img/EILIS.png"
                  width="100%"
                  @click="OfficialSite"/>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
      </div>
      <!-- <div id="yt-player"></div> -->
      <!-- 查無使用者 id -->
      <mu-dialog :title="$t('Member.system')" width="90%" :open="reloginDia">
        {{ $t('Member.page_expired') }}
        <mu-button slot="actions" flat color="primary" @click="redirectOfficial">{{ $t('Store.back') }}</mu-button>
      </mu-dialog>
      <!-- 首次登入訊息 -->
      <mu-dialog :title="$t('Member.system')" width="90%" :open="firstLoginDia">
        {{ firstMessage }}
        <mu-button slot="actions" flat color="primary" @click="hasLogin">確定</mu-button>
      </mu-dialog>
      <!-- 首次登入訊息 -->
      <mu-dialog :title="$t('Member.system')" width="90%" :open="showAlert">
        {{ $t('Member.not_member_yet') }}
        <mu-button slot="actions" flat color="primary" @click="redirectOfficial">{{ $t('Store.back') }}</mu-button>
      </mu-dialog>
      <!-- 電子郵件 -->
      <mu-dialog :title="$t('Member.system')"  width="90%" :open="emailDia">
        <mu-text-field v-model="inputEmail" placeholder="請輸入您的 Email" style="width: 100%;"></mu-text-field>
        <mu-button slot="actions" color="primary" @click="sendEmail">送出</mu-button>
      </mu-dialog>
      <!-- 點數小於零 -->
      <mu-dialog :title="$t('Member.system')" width="90%" :open="alertDia">
        <div>系統發生異常，請與客服人員聯絡。</div>
      </mu-dialog>
      <!-- 電話驗證 -->
      <mu-dialog title="完成註冊流程" width="90%" :open="phoneVerDia">
        <div v-if="progressPage === '1'">
          <div>請驗證你的電話號碼</div>
          <div style="margin-bottom: -5px;">
            <mu-select v-model="countryCode" style="width: 50%;" >
              <mu-option v-for="(code, index) in countries" :key="index" :label="$t(code.text)" :value="code.value"></mu-option>
            </mu-select>
          </div>
          <!-- 輸入電話欄位 -->
          <mu-row gutter>
            <mu-col span="8">
              <mu-text-field v-model="userPhone" full-width :placeholder="'例: ' + countries.filter(el => el.value === countryCode).map(el => el.example)[0]"></mu-text-field>
              <div v-if="phoneWarn" style="color: #f24; margin-top: -10px; margin-bottom: 10px;">{{ $t(warningMsg) }}</div>
            </mu-col>
            <mu-col span="4">
              <el-button type="primary" style="transform: translateY(-3px);" :disabled="userPhone === '' || number !== 0" @click="checkPhone"><span v-if="number === 0">{{ $t('Login.verify') }}</span><span v-if="number !== 0"> {{ number }}</span></el-button>
            </mu-col>
          </mu-row>
        </div>
        <div v-if="progressPage === '2'">
          <mu-row gutter>
            <mu-col span="8">
              <mu-text-field v-model="inputVer" full-width :placeholder="$t('Login.please_input_code')"></mu-text-field>
              <div v-if="phoneWarn" style="color: #f24; margin-top: -10px; margin-bottom: 10px;">{{ $t(warningMsg) }}</div>
            </mu-col>
            <mu-col span="4">
              <el-button type="primary" style="transform: translateY(-3px);" @click="checkVercode">{{ $t('Store.check') }}</el-button>
            </mu-col>
          </mu-row>
        </div>
        <mu-button v-if="progressPage === '2'" slot="actions" color="primary" @click="progressPage = '1'" flat>返回</mu-button>
      </mu-dialog>
      <!-- 選單 -->
      <div class="bottom_nav">
        <div class="bottomNav">
          <div style="width:100%; padding: 0; height: 65px;">
            <!-- 第一層選單 -->
            <mu-bottom-nav @change="show" style="background-color: inherit;" v-if="menuPage === '1'">
              <mu-bottom-nav-item v-for="(item, index) in firstList" :key="index + 'l1'" :title="$t(item.title)" :value="item.value" :icon="item.icon"></mu-bottom-nav-item>
            </mu-bottom-nav>
            <!-- 第二層選單 -->
            <mu-bottom-nav @change="show" style="background-color: inherit;" v-if="menuPage === '2'">
              <mu-bottom-nav-item v-for="(item, index) in secondList" :key="index + 'l1'" :title="$t(item.title)" :value="item.value" :icon="item.icon"></mu-bottom-nav-item>
            </mu-bottom-nav>
          </div>
        </div>
      </div>
      <FlashMessage></FlashMessage>
    </div>
  </div>
</template>

<script>
// 2. This code loads the IFrame Player API code asynchronously.
var tag = document.createElement('script');

tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
/* eslint-disable */
import QrcodeVue from 'qrcode.vue';
import VueClipboard from 'vue-clipboard2';
import esCard from './memberCard/card';
import esHistory from './memberCard/history';
import esShopInfo from './memberCard/shopinfo';
import esShop from './memberCard/shop';
import esShopLink from './memberCard/shoplink';
import esOrder from './memberCard/order';
import esBooking from './memberCard/booking';
import { mapGetters, mapActions, mapMutations } from 'vuex';

export default {
  data() {
    return {
      pageLoading: false,
      loadingMsg: 'Login.loading',
      menuPage: '1',
      progressPage: '1',
      activeIndex: '1',
      activeIndex2: '1',
      area: '',
      styleList: {
        height: '500px',
        overflow: 'auto'
      },
      firstList: [
        { title: 'Member.card', value: 'card', icon: 'chrome_reader_mode' },
        { title: 'Member.history', value: 'history', icon: 'restore' },
        { title: 'Member.shop', value: 'shop', icon: 'home' },
        { title: 'Member.more', value: 'more', icon: 'navigate_next' }
      ],
      secondList: [],
      // 電話驗證
      phoneVerDia: false,
      countries:[
        { text: 'Login.taiwan', value: '886', example: '0912345678' },
        { text: 'Login.korea', value: '82', example: '01012341234' },
        { text: 'Login.cambodia', value: '855', example: '091234567' },
        { text: 'Login.malaysia', value: '60', example: '0149052502' }
      ],
      phoneWarn: false,
      phoneVerify: false,
      number: 0,
      code: '',
      inputVer: '',
      verCode: '',
      warningMsg: '',
      countryCode: '886',
      oldPhone: '',
      showLogo: false,
      showCard: true,
      isMoblie: true,
      alertDia: false,
      uploadBox: true,
      uploading: false,
      uploadDia: false,
      checkUploadDia: false,
      hasLevel: false,
      hasEmail: false,
      invalidImg: false,
      pointDia: false,
      uploadTitle: 'Member.info',
      level: {
        list: [],
        nowLevel: '',
        type: '',
        activeStep: 1,
      },
      title: '',
      exp: 0,
      num: 'card',
      points: '--',
      // 使用者名稱
      inputEmail: '',
      username: '--',
      userEmail: '',
      // 使用者ID
      id: localStorage.getItem(this.$route.params.auth),
      // PageID 或是 ChannelID
      auth: this.$route.params.auth,
      // 平台 LINE or FB
      service: this.$route.params.service,
      barcode: '',
      invoice: false,
      reloginDia: false,
      qrcode: '',
      // 專頁名稱
      pageName: '',
      openQR: false,
      openBar: false,
      tableData: [],
      codetype: 'qr',
      originImg: 'https://image.flaticon.com/icons/svg/149/149071.svg',
      profileImg: 'https://image.flaticon.com/icons/svg/149/149071.svg',
      ratio: 50,
      upload: false,
      logo: '',
      second: 10,
      shopData: [],
      allStore: [],
      userTagList: [],
      shopStore: '',
      userTag: '',
      isShop: '',
      shopLink: '無',
      firstLoginDia: false,
      firstMessage: '',
      onlyLogo: false,
      showBtn: false,
      isBooking: false,
      showAlert: false,
      emailDia: false,
      height: 300,
      historyHeight: 300,
      webHeight: 300,
      shopHeight: 400,
      calendar: {},
      userPhone: '',
      referalUrl: '',
      customLink: '',
      memberUrl: '',
      isIframe: false,
      isOrder: false,
      videoId: 'wWB37NiBlao',
      player: {},
      linkType: 'A',
      linkArr: [],
      iframeData: {
        title: '商城',
        url: '',
        apiKey: ''
      },
      orderLink: ''
    };
  },
  computed: {
    ...mapGetters({
      pageDetail: 'pageDetail',
      userpoints: 'userpoints',
      accountDetail: 'accountDetail',
    }),
    userPointModel: {
      get() { return this.userpoints },
      set(value) { this.getPoints(value) }
    },
    enviroment() {
      if (location.hostname === 'members.eilis-ai.com') {
        return 'pro';
      }
      else {
        return 'dev';
      }
    },
  },
  components: {
    VueClipboard,
    esCard,
    esShopInfo,
    esShop,
    esHistory,
    esOrder,
    esBooking,
    QrcodeVue,
    esShopLink
  },
  mounted() {
    this.height           = (this.service === 'FB') ? window.screen.height * 0.39 : window.screen.height * 0.47;
    this.historyHeight    = (this.service === 'FB') ? window.screen.height * 0.47 : window.screen.height * 0.553;
    this.shopHeight       = (this.service === 'FB') ? window.screen.height * 0.534 : window.screen.height * 0.615;
    this.webHeight        = window.screen.height;
    this.styleList.height = `${window.screen.height * 0.78}px`;
    this.title            = 'Member.member_info';
    if (!this.pageDetail) {
      const aescode = localStorage.getItem('aescode');
      // 取得加密資料
      this.getDecryptData(aescode).then(() => {
        this.userTag = this.pageDetail.Tag;
        this.enviromentsetting();
      })
    }
    else {
      this.userTag = this.pageDetail.Tag;
      this.enviromentsetting();
    }
  },
  methods: {
    ...mapMutations({
      getPoints: 'getPoints'
    }),
    ...mapActions({
      sendSMS         : 'sendSMS',
      GetBasicID      : 'GetBasicID',
      updateUser      : 'updateUser',
      updateInfo      : 'updateInfo',
      checkUserFB     : 'checkUserFB',
      checkUserLINE   : 'checkUserLINE',
      changeUserPhone : 'changeUserPhone',
      getDecryptData  : 'getDecryptData',
      addUserTag      : 'addUserTag',
      getShopLink     : 'getShopLink',
      getOrderLink    : 'getOrderLink',
      getSend         : 'getSend',
      getDetail       : 'getDetail',
      getExchange     : 'getExchange',
      getStoreData    : 'getStoreData',
      checkAccount    : 'checkAccount',
      checkLoginStatus: 'checkLoginStatus',
      userFirstLogin  : 'userFirstLogin'
    }),
    enviromentsetting() {
      this.pageLoading = true;
      if (!this.id) {
        this.reloginDia = true;
        return;
      }
      if (this.$route.params.service === 'LINE') {
        this.GetBasicID({ channelID: this.$route.params.auth })
          .then((res) => {
            if (!res.data.Error) {
              this.referalUrl = `http://line.me/ti/p/${res.data.Report}`;
            }
          })
      }
      if (this.$route.params.service === 'FB') {
        this.referalUrl = `https://m.me/${this.$route.params.auth}`
      }
      // 先看 store 裡有沒有資料
      if (this.accountDetail) {
        this.setAccountData(this.accountDetail);
      }
      if (!this.accountDetail) {
        this.loadingMsg = 'Login.checking_page';
        this.checkAccount({ Service: this.service, Auth: this.auth })
          .then((res) => {
            this.setAccountData(res);
          })
      }
      this.getStoreData({ service: this.service, auth: this.auth });
      this.getDetail({ service: this.service, auth: this.auth, token: this.id });
      this.getSend({ service: this.service, auth: this.auth, token: this.id });
      this.getExchange({ service: this.service, auth: this.auth, token: this.id });
      if ( /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.isMoblie = true;
      }
      else {
        this.isMoblie = false;
      }
    },
    filterTab() {
      const card       = { title: 'Member.card'      , value: 'card'      , icon: 'chrome_reader_mode' };
      const store      = { title: 'Member.store'     , value: 'store'     , icon: 'location_on'        };
      const order      = { title: 'Member.order'     , value: 'iframe'    , icon: 'shopping_cart'      };
      const shop       = { title: 'Member.shop'      , value: 'shop'      , icon: 'home'               };
      const history    = { title: 'Member.history'   , value: 'history'   , icon: 'restore'            };
      const queryOrder = { title: 'Member.queryOrder', value: 'queryOrder', icon: 'search'             };
      const more       = { title: 'Member.more'      , value: 'more'      , icon: 'navigate_next'      };
      const back       = { title: 'Member.back'      , value: 'back'      , icon: 'navigate_before'    };

      if (this.isShop) {
        if (this.isIframe) {
          if (this.isOrder) {
            // order
            this.firstList  = [ card, store, order, shop, more ];
            // queryOrder
            this.secondList = [ back, history, queryOrder ];
          }
          else {
            // order
            this.firstList  = [ card, store, order, shop, history ];
          }
        }
        else {
          if (this.isOrder) {
            // queryOrder
            this.firstList  = [ card, history, shop, store, queryOrder ];
          }
          else {
            this.firstList  = [ card, history, shop, store ];
          }
        }
      }
      else {
        if (this.isIframe) {
          if (this.isOrder) {
            // order、queryOrder
            this.firstList  = [ card, order, store, history, queryOrder ];
          }
          else {
            // order
            this.firstList = [ card, order, store, history ];
          }
        }
        else {
          if (this.isOrder) {
            // queryOrder
            this.firstList = [ card, history, store, queryOrder ];
          }
          else {
            this.firstList = [ card, history, store ];
          }
        }
      }
    },
    setAccountData(content) {
      if (content) {
        this.checkService(content.firstloginMessage);
        this.pageName     = content.name;
        this.logo         = content.logo;
        this.showLogo     = true;
        this.memberUrl    = content.memberUrl;
        this.customLink   = content.customLink;
        this.firstMessage = content.firstloginMessage ? content.firstloginMessage : '';
        this.calendar     = content.calender          ? content.calender          : {};
        this.isBooking    = content.calender          ? true                      : false;
        this.upload       = content.upload            ? true                      : false;
        this.ratio        = content.ratio             ? parseInt(content.ratio)   : 50;
        this.invoice      = content.invoice           ? false                     : true;
        this.shopLink     = content.shopLink          ? content.shopLink          : '無';
        this.onlyLogo     = content.preLogo           ? true                      : false;
        // 特別資料
        if (this.customLink && this.memberUrl) {
          this.showBtn = true;
        }
        if (content.level) {
          this.level.type = content.level.type;
          this.level.list = content.level.list;
        }
        if (content.shop) {
          this.isShop    = true;
          this.shopData  = content.shop.items;
          this.allStore  = content.store;
          this.shopStore = content.shop.store
        }
      }
    },
    col() {
      if (!this.logo) {
        return 24;
      }
      if (this.logo && this.onlyLogo) {
        return 24;
      }
      return 12;
    },
    show(val) {
      if (this.menuPage === '1' && val === 'more') {
        this.menuPage = '2';
      }
      else if (this.menuPage === '2' && val === 'back') {
        this.menuPage = '1';
      }
      else {
        this.num = val;
      }
    },
    a() {
      this.number -= 1;
    },
    b() {
      this.number = 300;
      var si = setInterval(this.a, 1000);
      setTimeout(() => {
        this.number = 0;
        clearInterval(si);
      }, 300000);
    },
    checkVercode() {
      if (this.inputVer === this.verCode) {
        this.phoneVerDia = false;
        this.phoneWarn   = false;
        this.phoneVerify = true;
        this.pageLoading = true;
        this.warningMsg  = '';
        this.loadingMsg  = 'Login.awaiting_login';
        this.changeUserPhone({ service: this.service, auth: this.auth, originPhone: this.oldPhone, newPhone: this.userPhone, status: '已驗證' })
          .then(() => {
            window.location.reload();
          })
      }
      else {
        this.phoneWarn = true;
        this.warningMsg = 'Login.incorrect_code'; 
      }
    },
    checkPhone() {
      var re = /^[0-9]+$/;
      if (!re.test(this.userPhone)) { 
        this.phoneWarn = true;
        this.warningMsg = 'Login.informat_phone'; 
  　　 }
      else {
        const random = new Array('0','1','2','3','4','5','6','7','8','9');
        let code = '';
        for (let e = 0; e < 6; e += 1) {
          const index = Math.floor(Math.random() * 10);
          code += random[index];
        }
        this.phoneWarn   = false;
        this.warningMsg  = '';

        this.verCode = code;
        this.b();
        this.sendSMS({ phone: this.userPhone, code: this.verCode, service: this.service, auth: this.auth, countryCode: this.countryCode })
          .then((resp) => {
            if (resp.data.code === '00000') {
              this.progressPage = '2';
            }
            else {
              this.phoneWarn = true;
              this.warningMsg = 'Login.error_occured';
            }
          })
      }
    },
    closeFullscreenDialog() {
      this.profileImg = this.originImg;
      this.uploadDia = false;
      this.uploadBox = true;
      this.uploadTitle = 'Member.info';
    },
    doCopy() {
      this.$copyText(this.referalUrl);
      this.flashMessage.success({
        title: 'Copied to clipboard!',
        time: 1000
      });
    },
    openUpload() {
      this.uploadDia = true;
      this.originImg = this.profileImg;
    },
    // 上傳圖片到 DB
    onFileSelected(event) {
      // 使用者 uid
      const uid = localStorage.getItem('UserID');
      // 檔案
      const file = event.target.files[0];
      if (file && (file.type === 'image/jpeg' || file.type === 'image/png')) {
        this.invalidImg = false;
        this.uploading = true;
        const formData = new FormData();
        formData.append('uid', uid);
        formData.append('myfile', file);

        const config = {
          header: {
            "content-type": "multipart/form-data"
          }
        };
        // 上傳表單資料
        this.axios.post('https://member-card.herokuapp.com/upload', formData, config)
          .then((res) => {
            this.profileImg = res.data.url;
            setTimeout(() => {
              this.uploading = false;
            }, 1000);
          })
          .catch((err) => {
            setTimeout(() => {
              this.uploading = false;
            }, 1000);
          });
      }
      else {
        this.invalidImg = true;
      }
    },
    checkImg() {
      this.uploadBox = false;
      this.uploadTitle = 'Member.check_img';
    },
    getBack() {
      this.uploadBox = true;
      this.uploadTitle = 'Member.upload';
    },
    refresh() {
      window.location.reload();
    },
    OfficialSite() {
      window.open('https://www.eilis-ai.com/');
    },
    redirectOfficial() {
      localStorage.clear();
      window.history.go(-1);
    },
    sendEmail() {
      this.emailDia = false;
      const postData = {
        service: this.service, auth: this.auth,
        token: this.id, phone: this.userPhone,
        update: { Email: this.inputEmail }
      };
      this.updateInfo(postData);
    },
    checkUpload() {
      this.checkUploadDia = true;
    },
    sendUpload() {
      this.checkUploadDia = false;
      this.pageLoading    = true;
      this.loadingMsg     = 'Login.loading'
      const postData      = {
        Service: this.service, Auth: this.auth,
        Token: this.id,
        UpdateData: {
          ProfileImg: this.profileImg
        }
      };
      this.updateUser(postData).then(() => {
        this.pageLoading = false;
        this.uploadDia   = false;
      });
    },
    // 計算會員等級
    countEXP(exp) {
      const explist = this.level.list ? this.level.list.map(el => parseInt(el.exp)) : [];
      if (explist && explist.length > 0) {
        this.hasLevel = true;
        for (let i = 0; i < explist.length; i += 1) {
          const index = i;
          if (!exp) {
            this.level.nowLevel = '';
            this.level.activeStep = 0;
            return;
          }
          if (index === 0 && explist[index] > exp) {
            this.level.nowLevel = '';
            this.level.activeStep = 0;
            return;
          }
          if (explist[index] <= exp && exp < explist[index + 1]) {
            this.level.nowLevel = this.level.list[index].title;
            this.level.activeStep = index + 1;
            return;
          }
          if ((index === explist.length - 1) && explist[index] <= exp) {
            this.level.nowLevel = this.level.list[index].title;
            this.level.activeStep = explist.length;
            return;
          }
        }
      }
    },
    getOrderData(postData) {
      return this.getOrderLink(postData).then((res) => {
        if (res.data.Link) {
          this.isOrder = true;
          this.orderLink = res.data.Link;
        }
        return Promise.resolve(true);
      })
    },
    getShopData(postData) {
      return this.getShopLink(postData).then((res) => {
        if (res.data.Type) {
          this.isIframe = true;
          this.linkType = res.data.Type;
          if (res.data.Type === 'A' || res.data.Type === 'C') {
            this.iframeData.url = res.data.Link;
          }
          else {
            this.linkArr = res.data.Links;
          }
        }
        return Promise.resolve(true);
      })
    },
    getShopLinkData(user) {
      const name  = user['Name'];
      const birth = user['ID'];
      const point = user['Points'];
      const phone = user['Phone'];
      const postData = {
        clientId: this.auth, name, birth, point, phone, envir: this.enviroment
      };
      const promises = [this.getShopData(postData), this.getOrderData(postData)]
      return Promise.all([...promises])
        .then(() => {
          this.pageLoading = false;
          this.filterTab();
        })
    },
    generateCode(phone) {
      const CodedPhone = Math.floor((Math.random() * (99 - 11))).toString() + phone.toString() + Math.floor((Math.random() * (99 - 11))).toString();
      const transformPhone = CodedPhone.replace(/0/g, 'a').replace(/1/g, 'b').replace(/2/g, 'c').replace(/3/g, 'd').replace(/4/g, 'e').replace(/5/g, 'f').replace(/6/g, 'g').replace(/7/g, 'h').replace(/8/g, 'i').replace(/9/g, 'j');
      this.num = 'card';
      this.qrcode = transformPhone;
      this.barcode = `https://bwipjs-api.metafloor.com/?bcid=code128&text=${transformPhone}&scaleY=0.4`
    },
    hasLogin() {
      this.firstLoginDia = false;
      this.userFirstLogin({ service: this.service, auth: this.auth, phone: this.userPhone });
    },
    // 取得使用者基本資料
    receiveUserData(service, user, message) {
      this.getShopLinkData(user);
      this.exp = user.EXP ? parseInt(user.EXP) : 0;
      this.countEXP(this.exp);
      this.profileImg = user.ProfileImg ? user.ProfileImg : 'https://image.flaticon.com/icons/svg/149/149071.svg';
      this.userPointModel = (user.Points) ? parseInt(user.Points) : 0;
      this.userPhone = user.Phone;
      this.userEmail = (user.Email && user.Email !== '無資料') ? user.Email : '';
      // 如果用戶有 tag
      if (user.Tag) {
        this.userTagList = Object.keys(user.Tag);
      }
      // 點數 <0 鎖帳號
      // if (this.userPointModel < 0) {
      //   this.alertDia = true;
      // }
      // 自動上 tag
      if (this.userTag) {
        this.addUserTag({ service: service, auth: this.auth, phone: this.userPhone, tag: this.userTag, bindServ: [service] });
      }
      // 如果有用戶姓名
      if (user.Name) {
        this.username = user.Name;
      }
      else { 
        this.username = '--';
      }
      // 確定有沒有第一次登入問候
      if (message && message !== '') {
        this.generateCode(user.Phone);
        this.checkLoginStatus({ service: service, auth: this.auth, phone: user.Phone })
          .then((res) => {
            if (res.data && res.data.Status && res.data.Status.login) {
              this.firstLoginDia = false;
            }
            else {
              this.firstLoginDia = true;
            }
          })
      }
      else {
        this.generateCode(user.Phone);
      }
    },
    checkService(message) {
      this.loadingMsg = 'Login.get_user_data';
      if (this.service === 'LINE') {
        this.checkUserLINE({ ChannelID: this.auth, UserID: this.id })
          .then((res) => {
            // this.pageLoading = false;
            if (res.data.Detail) {
              if (res.data.Detail.status === '未驗證') {
                this.pageLoading = false;
                this.userPhone    = res.data.Detail.Phone;
                this.oldPhone     = res.data.Detail.Phone;
                this.progressPage = '1';
                this.phoneVerDia  = true;
              }
              else {
                this.receiveUserData('LINE', res.data.Detail, message);
              }
            } 
            else {
              this.showAlert = true;
            }
          });
      }
      else {
        this.checkUserFB({ PageID: this.auth, PSID: this.id })
          .then((res) => {
            // this.pageLoading = false;
            if (res.data.Detail) {
              if (res.data.Detail.status === '未驗證') {
                this.pageLoading = false;
                this.userPhone    = res.data.Detail.Phone;
                this.oldPhone     = res.data.Detail.Phone;
                this.progressPage = '1';
                this.phoneVerDia  = true;
              }
              else {
                this.receiveUserData('FB', res.data.Detail, message);
              }
            } 
            else {
              this.showAlert = true;
            }
          });
      }
    },
  },
}
</script>

<style scoped>
  #app {
    padding-top: 15px;
  }
  .bottom_nav {
    width: 100%;
  }
  .tag {
    display: inline-block;
    font-size: 12px;
    padding: 1px 10px;
    border-radius: 3px;
    border: 1px solid #1497fa;
    color: #1497fa;
    background-color: rgba(8, 121, 207, 0.1);
  }
  .bottomNav {
    position: fixed;
    bottom: 0;
    width: 100%;
    padding-top: 5px;
    padding-bottom: 5px;
    background-color: #555;
    height: 73px;
  }
  .mu-bottom-item {
    background-color: inherit !important;
    padding: 10px;
    height: 65px;
    background-clip: padding-box;
    color: #fff;
  }
  .dup {
    transform: translateY(7px);
    cursor: pointer;
    font-size: 26px;
    transition: 0.3s;
  }
  .btn-info {
    background-color: #409eff;
    cursor: pointer;
    font-size: 12px;
    border-radius: 3px;
    color: #fff;
    padding: 7.5px 15px;
  }
  .mu-bottom-item-active {
    color:#fcda3f;
  }
  .web {
    text-decoration: none;
    color: #888;
    transition: 0.2s;
  }
  .web:hover {
    color: #f24;
  }
</style>